import { render, staticRenderFns } from "./GynecologyPrint.vue?vue&type=template&id=173a942f&"
import script from "./GynecologyPrint.vue?vue&type=script&lang=js&"
export * from "./GynecologyPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports